import { useState, useEffect } from "react";
import { createUser, getUsers, updateUser } from "../api/adminApi"

export default function UserManagement() {
  const [form, setForm] = useState({
    id: null,
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    roles: ["ROLE_USER"],
  });
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const data = await getUsers();
      setUsers(data);
    } catch (error) {
      setMessage("Erreur lors du chargement des utilisateurs.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      setMessage("Les mots de passe ne correspondent pas !");
      return;
    }
    try {
      if (isEditing) {
        await updateUser(form);
        setMessage("Utilisateur mis à jour avec succès !");
      } else {
        await createUser(form);
        setMessage("Utilisateur créé avec succès !");
      }
      resetForm();
      fetchUsers();
    } catch (error) {
      setMessage(error.message || "Erreur lors de la sauvegarde.");
    }
  };

  const handleEdit = (user) => {
    setForm({
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      password: "",
      confirmPassword: "",
      roles: user.roles,
    });
    setIsEditing(true);
  };

  const resetForm = () => {
    setForm({
      id: null,
      firstName: "",
      lastName: "",
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      roles: ["ROLE_USER"],
    });
    setIsEditing(false);
  };

  const toggleRole = (role) => {
    setForm((prev) => ({
      ...prev,
      roles: prev.roles.includes(role)
        ? prev.roles.filter((r) => r !== role)
        : [...prev.roles, role],
    }));
  };

  return (
    <div style={{ display: "flex", gap: "30px" }}>
      {/* Form */}
      <div
        style={{
          flex: 1,
          backgroundColor: "#1e1e2c",
          padding: "20px",
          borderRadius: "8px",
          border: "2px solid #00ff9d",
          color: "#00ff9d",
          fontFamily: '"Press Start 2P", cursive',
        }}
      >
        <h2 style={{ marginBottom: "20px", fontSize: "1.2rem" }}>
          {isEditing ? "MODIFIER UTILISATEUR" : "CRÉER UTILISATEUR"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "3px", fontSize: "0.7rem" }}>PRÉNOM</label>
            <input
              type="text"
              value={form.firstName}
              onChange={(e) => setForm({ ...form, firstName: e.target.value })}
              required
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "3px", fontSize: "0.7rem" }}>NOM</label>
            <input
              type="text"
              value={form.lastName}
              onChange={(e) => setForm({ ...form, lastName: e.target.value })}
              required
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "3px", fontSize: "0.7rem" }}>NOM D'UTILISATEUR</label>
            <input
              type="text"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              required
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "3px", fontSize: "0.7rem" }}>E-MAIL</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "3px", fontSize: "0.7rem" }}>MOT DE PASSE</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required={!isEditing}
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", marginBottom: "3px", fontSize: "0.7rem" }}>CONFIRMER MOT DE PASSE</label>
            <input
              type="password"
              value={form.confirmPassword}
              onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
              required={!isEditing}
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontSize: "0.7rem" }}>RÔLES</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {["ROLE_USER", "ROLE_ADMIN"].map((role) => (
                <label key={role} style={{ fontSize: "0.7rem" }}>
                  <input
                    type="checkbox"
                    checked={form.roles.includes(role)}
                    onChange={() => toggleRole(role)}
                    style={{ marginRight: "5px" }}
                  />
                  {role}
                </label>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button type="submit" style={buttonStyle}>
              {isEditing ? "METTRE À JOUR" : "CRÉER"}
            </button>
            {isEditing && (
              <button type="button" onClick={resetForm} style={{ ...buttonStyle, backgroundColor: "#ff79c6" }}>
                ANNULER
              </button>
            )}
          </div>
        </form>
        {message && <p style={{ marginTop: "10px", color: message.includes("succès") ? "#00ff9d" : "#ff79c6", fontSize: "0.7rem" }}>{message}</p>}
      </div>
      

      {/* Lista utenti */}
      <div
        style={{
          flex: 1,
          backgroundColor: "#1e1e2c",
          padding: "20px",
          borderRadius: "8px",
          border: "2px solid #00ff9d",
          color: "#00ff9d",
          fontFamily: '"Press Start 2P", cursive',
          maxHeight: "600px",
          overflowY: "auto",
        }}
      >
        <h2 style={{ marginBottom: "15px", fontSize: "1.2rem" }}>UTILISATEURS EXISTANTS</h2>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={tableHeaderStyle}>NOM D'UTILISATEUR</th>
              <th style={tableHeaderStyle}>PRÉNOM</th>
              <th style={tableHeaderStyle}>NOM</th>
              <th style={tableHeaderStyle}>E-MAIL</th>
              <th style={tableHeaderStyle}>RÔLES</th>
              <th style={tableHeaderStyle}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} style={{ borderBottom: "1px solid #00ff9d33" }}>
                <td style={tableCellStyle}>{user.username}</td>
                <td style={tableCellStyle}>{user.firstName}</td>
                <td style={tableCellStyle}>{user.lastName}</td>
                <td style={tableCellStyle}>{user.email}</td>
                <td style={tableCellStyle}>{user.roles.join(", ")}</td>
                <td style={tableCellStyle}>
                  <button
                    onClick={() => handleEdit(user)}
                    style={{ ...smallButtonStyle, backgroundColor: "#00ff9d" }}
                  >
                    MODIFIER
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "6px",
  backgroundColor: "#2a2a4a",
  border: "1px solid #00ff9d",
  borderRadius: "4px",
  color: "#e0e0e0",
  fontFamily: '"Courier New", monospace',
  fontSize: "0.8rem",
};

const buttonStyle = {
  padding: "6px 12px",
  backgroundColor: "#00ff9d",
  color: "#1e1e2c",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontFamily: '"Press Start 2P", cursive',
  fontSize: "0.6rem",
};

const smallButtonStyle = {
  padding: "4px 8px",
  backgroundColor: "#00ff9d",
  color: "#1e1e2c",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontFamily: '"Press Start 2P", cursive',
  fontSize: "0.6rem",
};

const tableHeaderStyle = {
  padding: "8px",
  textAlign: "left",
  fontSize: "0.7rem",
  borderBottom: "1px solid #00ff9d",
};

const tableCellStyle = {
  padding: "8px",
  fontSize: "0.7rem",
};
